import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ScriptList, { ScriptItem } from "../../ScriptList/ScriptList";
import { useScriptSearch } from "../../../../hooks/chatScript/useScriptSearch";
import Loader from "../../../loader/Loader";
import "./ScriptPickerSearch.less";
import useFetchUserInfos from "../../../../hooks/userHooks/useFetchUserInfos";

export type ScriptPickerSearchProps = {
  allItems: ScriptItem[];
  onCancel: () => void;
  alreadySentIds?: string[];
  onSend: (item: ScriptItem) => void;
};

const ScriptPickerSearch: React.FC<ScriptPickerSearchProps> = ({ allItems, onCancel, alreadySentIds = [], onSend }) => {
  const { t } = useTranslation();
  const { currentUser } = useFetchUserInfos();
  const currentCreator = currentUser?.id;
  const [query, setQuery] = useState("");
  const { shouldUseBackend, items, loading, listRef, sentinelRef } = useScriptSearch({ query, allItems, creatorId: currentCreator });

  return (
    <div className="script-picker-search">
      <div className="search-bar">
        <input className="search-input" placeholder={t("search") as string} value={query} onChange={(e) => setQuery(e.target.value)} autoFocus />
        <button className="search-cancel" onClick={onCancel} type="button">
          {t("cancel")}
        </button>
      </div>
      <div className="search-results">
        {shouldUseBackend ? (
          loading && items.length === 0 ? (
            <div className="loader-wrapper">
              <Loader />
            </div>
          ) : items.length === 0 ? (
            <div className="search-empty">{t("search-no-results")}</div>
          ) : (
            <>
              <ScriptList
                items={items}
                loading={loading && items.length === 0}
                listRef={listRef}
                sentinelRef={sentinelRef}
                pickerMode
                alreadySentIds={alreadySentIds}
                onSend={onSend}
              />
              {loading && items.length > 0 && (
                <div className="loader-script-wrapper">
                  <Loader />
                </div>
              )}
            </>
          )
        ) : (
          <ScriptList
            items={items}
            pickerMode
            alreadySentIds={alreadySentIds}
            onSend={onSend}
          />
        )}
      </div>
    </div>
  );
};

export default ScriptPickerSearch;
